import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
	providedIn: 'root'
})
export class TokenService {
	private helper = new JwtHelperService();

	saveAccessToken(accessToken: string) {
		sessionStorage.setItem('access_token', accessToken);
	}

	getAccessToken(): string | null {
		return sessionStorage.getItem('access_token');
	}

	isValidAccessToken(): boolean {
		return !this.helper.isTokenExpired(this.getAccessToken());
	}
}
